import { render, staticRenderFns } from "./formatos.vue?vue&type=template&id=7d20542c&scoped=true"
import script from "./formatos.vue?vue&type=script&lang=js"
export * from "./formatos.vue?vue&type=script&lang=js"
import style0 from "./formatos.vue?vue&type=style&index=0&id=7d20542c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d20542c",
  null
  
)

export default component.exports